export default __webpack_public_path__ + "static/media/safs-hochschule.43fb5604.svg";